import request from 'superagent';
import Cookies from 'js-cookie';
import {getDeviceSource} from 'utils/deviceSource';
import {getAuthParams, withRefreshRetry, handleUnauthorized} from './utils';
import {domain} from 'ferries/helpers/common';

const getUserAccount = () => {
  const {uuid} = getAuthParams();
  const tp24Id = Cookies.get('TP24ID');

  const makeRequest = () =>
    request
      .get(`${domain}/api/users/${uuid}?basicData=true${tp24Id ? `&tp24Id=${tp24Id}` : ''}`)
      .set({'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Device-Source': getDeviceSource()})
      .ok(({status}) => [200, 401].includes(status))
      .then(({body, status}) => ({body, status}));

  return withRefreshRetry(makeRequest).then(({body, status}) => {
    if (status === 401) {
      handleUnauthorized();
    }
    return {body, status};
  });
};

export {getUserAccount};
